<template>
  <div id="iDDPortal" class="micor-app-box"></div>
</template>

<script>
const getActiveRule = hash => location => location.hash.startsWith(hash)
import { loadMicroApp } from 'qiankun'
export default {
  name: 'iDDPortal',
  data() {
    return {
      microApp: null,
    }
  },
  watch: {
    $route: function(val, oldVal) {
      this.microApp.update({ routeChange: { to: val, from: oldVal } })
    },
  },
  methods: {},
  mounted() {
    this.$store.commit('updateProduct', 'idd')
    let currentRoute = this.$route.fullPath
    this.microApp = loadMicroApp(
      {
        name: 'iDDPortal', //应用名字
        entry:
          process.env.NODE_ENV === 'production'
            ? '/iDDPortal/'
            : '//localhost:7878', //默认会加载这个HTML 动态加载资源 （必须支持跨域）
        // fetch
        container: '#iDDPortal', //容器名
        activeRule: getActiveRule('#/child-iDDPortal'), //激活路径
        props: {
          fatherRouter: this.$router,
          currentRoute,
        },
      },
      {
        singular: false,
      }
    )
  },
  beforeDestroy() {
    this.$store.commit('updateProduct', '')
    this.microApp.unmount()
  },
}
</script>

<style scoped></style>
